import unauthenticatedFetch from 'services/rest/unauthenticatedFetch';
import { Headers } from 'shared/constants/headers';
import { z } from 'zod';

export interface SelectChallengeData {
  allow1FA?: boolean;
  challengeId: string;
  identityId: string;
  isCallForResendCode?: boolean;
}

// Define schema for challenge object
const challengeSchema = z.object({
  challengeId: z.string(),
  challengeContext: z.string(),
  challengeType: z.string(),
  challengeState: z.string(),
});

// Define schema for UI data object
const uiDataSchema = z.object({
  allowResendSeconds: z.number(),
  maskedEmail: z.string(),
  maskedPhone: z.string(),
});

// Define schema that matches SelectChallengeResponse
const selectChallengeResponseSchema = z.object({
  challenge: challengeSchema.optional(),
  challengeId: z.string().optional(),
  challengeContext: z.string().optional(),
  challengeType: z.string().optional(),
  challengeState: z.string().optional(),
  uiData: uiDataSchema.optional(),
  title: z.string().optional(),
  errorCode: z
    .union([z.string(), z.number()])
    .transform((value) => Number(value))
    .optional(),
  message: z.string().optional(),
});

// Extract type from schema
export type SelectChallengeResponse = z.infer<
  typeof selectChallengeResponseSchema
>;

export default async function fetchSelectChallenge(
  lambdaUrl: string,
  data: SelectChallengeData,
  headers: Headers,
) {
  const response = await unauthenticatedFetch(`${lambdaUrl}/select-challenge`, {
    method: 'POST',
    cache: 'no-cache',
    body: JSON.stringify(data),
    headers,
  });

  const result: unknown = await response.json();
  return selectChallengeResponseSchema.parse(result);
}
